import { motion } from "framer-motion";
import { OTHER_BOOKS, SHOW_OTHER_BOOKS, SITE } from "../config";

export const OtherBooks = () => {
  if (!SHOW_OTHER_BOOKS) return null;
  return (
    <section id="also-by" data-testid="other-books-section" className="relative py-24 md:py-36 max-w-[1600px] mx-auto px-6 md:px-12">
      <div className="mb-14 md:mb-20 max-w-3xl">
        <p className="font-grotesk uppercase tracking-[0.35em] text-xs text-[#d8ab4e] mb-6">Also by the Author</p>
        <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">
          More from <span className="gold-text italic">{SITE.author}</span>.
        </h2>
        <p className="mt-6 font-body text-[#9a8f78] text-lg">
          Two earlier works of non-fiction — part of an ongoing exploration of truth, wealth, and what endures.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
        {OTHER_BOOKS.map((b, i) => {
          const live = Boolean(b.href);
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`other-book-${i}`}
              className="group flex gap-8 items-center"
            >
              {/* Cover / placeholder */}
              <div className="shrink-0 w-32 sm:w-40 aspect-[7/10] gold-glow overflow-hidden">
                {b.cover ? (
                  <img src={b.cover} alt={b.title} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center bg-[#12100a] border border-[#d8ab4e]/25 p-4 text-center">
                    <span className="font-grotesk uppercase tracking-[0.3em] text-[10px] text-[#7d7460] mb-3">Ian Jones</span>
                    <span className="font-display italic text-lg gold-text leading-tight">{b.title}</span>
                  </div>
                )}
              </div>

              {/* Details */}
              <div>
                <h3 className="font-display text-2xl sm:text-3xl text-[#f3ead6] group-hover:text-[#f2c968] transition-colors">{b.title}</h3>
                <p className="mt-3 font-body text-[#a89d84]">{b.description}</p>
                {live ? (
                  <a
                    href={b.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`other-book-link-${i}`}
                    className="mt-5 inline-flex items-center gap-2 text-[#d8ab4e] uppercase tracking-[0.2em] text-sm hover-underline"
                  >
                    Learn more <span className="transition-transform group-hover:translate-x-1">→</span>
                  </a>
                ) : (
                  <span className="mt-5 inline-block font-grotesk uppercase tracking-[0.2em] text-xs text-[#6b6350]">Details coming soon</span>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default OtherBooks;
